import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { reducer as reduxFormReducer } from 'redux-form';
import {
  themeReducer,
  rtlReducer,
  cryptoTableReducer,
  customizerReducer,
  newOrderTableReducer,
  sidebarReducer,
  authReducer,
  roundBordersReducer,
  blocksShadowsReducer,
  revenueReducer,
  productReducer,
  marketPlaceReducer,
  compareMonthSalesReducer,
  salesCategoryByDayReducer,
  salesBreakdownReducer,
  salesByRegionReducer,
  aovReducer,
  categorySalesReducer,
  customerReducer,
  OrderReducer,
  SubscribersByCategoryReducer,
  profitReducer,
  monthlySubscriptionReducer,
  revenueFromSubscriptionReducer,
  promotionByRevenueReducer,
  monthEndInventoryReducer,
  inventoryFBAForecastReducer,
  advBudgetPerformanceReducer,
  newReturnCustomerReducer,
  advSalesReducer,
  advProductsReducer,
  advKeywordsReducer,
  advCampaignReducer,
  subscribersReducer,
  pageTrafficWithConversionReducer,
  repurchaseRateReducer,
  dashboardReducer,
  bestReportsReportReducer,
  basketAnalysisReducer,
  lifeTimeValueReducer,
  wholesaleCustomerReducer,
  wholesaleOrderReducer,
  revenueFromCustomerReducer,
  koreaRevenueReducer,
  koreaRevenueByCustomerReducer,
  salesReducer,
  salesByProductReducer,
  posReducer,
  compareMonthAllReducer,
  sessionByReferrerReducer,
  sessionByReferrerAllReducer,
  salesByReferrerReducer,
  salesByReferrerAllReducer,
  salesByChannelReducer,
  salesByChannelAllReducer,
  virtualBundleSalesReducer,
  virtualBundleSalesUploadDetailsReducer,
  promotionsForPrimeReducer,
  customerTransitionReducer,
  dataIngestionBatchStatusReducer,
  SKUReducer,
  SearchPositionTrackerReducer,
  PerformanceBySKUReducer,
  ReturnRefundByDayReducer,
  ReturnRefundByMonthReducer,
  TaxReducer
} from '../../redux/reducers/index'

import appConfigReducer from '../../redux/reducers/appConfigReducer';

import covidReducer from '../Maps/VectorMapWithRequestData/redux/covidReducer';
// import todoReducer from '../Todo/redux/reducer';

const reducer = combineReducers({
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  rtl: rtlReducer,
  roundBorders: roundBordersReducer,
  blocksShadows: blocksShadowsReducer,
  appConfig: appConfigReducer,
  cryptoTable: cryptoTableReducer,
  customizer: customizerReducer,
  newOrder: newOrderTableReducer,
  sidebar: sidebarReducer,
  user: authReducer,
  covid: covidReducer,
  // todo: todoReducer,
  revenueReducer,
  productReducer,
  marketPlaceReducer,
  compareMonthSalesReducer,
  salesCategoryByDayReducer,
  salesBreakdownReducer,
  salesByRegionReducer,
  aovReducer,
  categorySalesReducer,
  customerReducer,
  OrderReducer,
  SubscribersByCategoryReducer,
  profitReducer,
  monthlySubscriptionReducer,
  revenueFromSubscriptionReducer,
  promotionByRevenueReducer,
  monthEndInventoryReducer,
  inventoryFBAForecastReducer,
  advBudgetPerformanceReducer,
  newReturnCustomerReducer,
  advSalesReducer,
  advProductsReducer,
  advKeywordsReducer,
  advCampaignReducer,
  subscribersReducer,
  pageTrafficWithConversionReducer,
  repurchaseRateReducer,
  dashboardReducer,
  bestReportsReportReducer,
  basketAnalysisReducer,
  lifeTimeValueReducer,
  wholesaleCustomerReducer,
  wholesaleOrderReducer,
  revenueFromCustomerReducer,
  koreaRevenueReducer,
  koreaRevenueByCustomerReducer,
  salesReducer,
  salesByProductReducer,
  posReducer,
  compareMonthAllReducer,
  sessionByReferrerReducer,
  sessionByReferrerAllReducer,
  salesByReferrerReducer,
  salesByReferrerAllReducer,
  salesByChannelReducer,
  salesByChannelAllReducer,
  virtualBundleSalesReducer,
  virtualBundleSalesUploadDetailsReducer,
  promotionsForPrimeReducer,
  customerTransitionReducer,
  dataIngestionBatchStatusReducer,
  SKUReducer,
  SearchPositionTrackerReducer,
  PerformanceBySKUReducer,
  ReturnRefundByDayReducer,
  ReturnRefundByMonthReducer,
  TaxReducer
});
const store = createStore(reducer, applyMiddleware(thunk));

export default store;
